import { Component, HostListener, ViewContainerRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { Services } from '../app.service';
import { SecurityManager } from '../app.sec.component';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { forEach } from '@angular/router/src/utils/collection';
import { requestCounter } from 'app/app.module';


export function startScrolling(obj, param, scrolling) {

  obj.animate({
    scrollLeft: param
  }, 30, function () {
    startScrolling(obj, param, false);
  });
}





declare var jQuery: any;

declare var $: any;
declare var moment: any;
@Component({
  providers: [Services, SecurityManager],
  templateUrl: './app.card.component.html'
})
export class CardComponent implements OnInit {
  startScrolling: (obj: any, param: any, scrolling: any) => void;




  Var = {
    monthesOfYear: [{
      id: 1,
      title: 'فروردین',
      days: 31
    }, {
      id: 2,
      title: 'اردیبهشت',
      days: 31
    }, {
      id: 3,
      title: 'خرداد',
      days: 31
    }, {
      id: 4,
      title: 'تیر',
      days: 31
    }, {
      id: 5,
      title: 'مرداد',
      days: 31
    }, {
      id: 6,
      title: 'شهریور',
      days: 31
    }, {
      id: 7,
      title: 'مهر',
      days: 30
    }, {
      id: 8,
      title: 'آبان',
      days: 30
    }, {
      id: 9,
      title: 'آذر',
      days: 30
    }, {
      id: 10,
      title: 'دی',
      days: 30
    }, {
      id: 11,
      title: 'بهمن',
      days: 30
    }, {
      id: 12,
      title: 'اسفند',
      days: 30
    }]
  }

  // tslint:disable-next-line:prefer-const
  attachment = false;
  date = null;
  selectedListDate = null;
  selectedCardToDelete = null;
  selectedCard = null;
  showConfrimModal = false;
  showCardModal = false;
  showSelectDayModal = false;
  selectedSpecificDate = null;
  selectedTab = null;
  preventGetListRequests = false;
  cardSearchList = null;
  initialized = false;
  showNotificationModal = false;
  notificationMessage = '';
  searchBox = null;
  cardList = null;
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef,
    private services: Services, private security: SecurityManager, private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);



    const mm = moment();

    this.date = {
      Day: mm.jDate(),
      Month: mm.jMonth() + 1,
      Year: mm.jYear(),
      DaysBefore: ((mm.day() + 8) % 7),
      DaysAfter: 6 - ((mm.day() + 8) % 7)
    }



  }

  closeCardModal() {
    this.showCardModal = false;
    this.selectedListDate = null;
  }


  cardActionFinished = function (card) {



    this.closeCardModal();




    // const date = {
    //   Day: this.cardList.Lists[0].Day.Day,
    //   Month: this.cardList.Lists[0].Day.Month,
    //   Year: this.cardList.Lists[0].Day.Year,
    //   DaysBefore: 0,
    //   DaysAfter: this.cardList.Lists.length - 1
    // }
    $('.PageLoading').slideDown()

    if (this.cardSearchList) {


      card.ID = card.CardGUID;
      this.services.updateCard(card).subscribe(
        (data) => {
          $('.PageLoading').slideUp()
          if (data.RStatus === 'Success') {
            this.onSearchClick();

            this.toastr.success('کارت با موفقیت  ذخیره شد.', 'عملیات موفق');


          } else {


            this.toastr.error('ذخیره کارت با مشکل  مواجه شد.', 'عملیات ناموفق');

          }

        },
        (err) => { $('.PageLoading').slideUp() });




    } else {

      if (!card.CardGUID) {



        this.services.saveCard(card).subscribe(
          (data) => {
            $('.PageLoading').slideUp()
            if (data.RStatus === 'Success') {

              this.services.getCardList(this.date).subscribe(
                (res) => {


                  res.Lists.forEach((List, i) => {


                    this.cardList.Lists[i] = List;



                  });


                },
                (err) => {


                });


              this.toastr.success('کارت با موفقیت  ذخیره شد.', 'عملیات موفق');

            } else {


              this.toastr.success('ذخیره کارت با مشکل  مواجه شد.', 'عملیات ناموفق');

            }




          },
          (err) => { $('.PageLoading').slideUp() });
      } else {
        card.ID = card.CardGUID;
        this.services.updateCard(card).subscribe(
          (data) => {
            $('.PageLoading').slideUp()
            if (data.RStatus === 'Success') {
              this.toastr.success('کارت با موفقیت  ذخیره شد.', 'عملیات موفق');

              this.services.getCardList(this.date).subscribe(
                (res) => {



                  res.Lists.forEach((List, i) => {


                    this.cardList.Lists[i] = List;



                  });


                },
                (err) => {

                  $('.PageLoading').slideUp()
                });
            } else {


              this.toastr.error('ذخیره کارت با مشکل  مواجه شد.', 'عملیات ناموفق');

            }

          },
          (err) => { $('.PageLoading').slideUp() });
      }

    }








  }


  handleSelectDay = function (date) {

    this.showSelectDayModal = false;
    this.selectedSpecificDate = date;
    this.getSettings();
    this.getCardList(date, true);




  }

  generateCardTime(Hour, Minute) {
    let time = '';
    time += Hour + ':';
    if (Minute < 10) {
      time += '0' + Minute;
    } else {
      time += Minute;
    }

    return time;
  }


  getLastUserMessageID() {
    let id = localStorage.getItem('UserMessage');
    if (!id) { id = '0' }
    return Number(id);
  }
  saveUserMessageID(id) {
    localStorage.setItem('UserMessage', id);
  }

  getSettings = function () {
    this.services.getSettings().subscribe(
      (data) => {
        this.settings = data.Setting;

        let UserMessageID;

        this.settings.forEach((item, i) => {
          if (item.Key === 'UserMessageID') {

            UserMessageID = Number(item.Value1);



          }
        });
        if (UserMessageID > this.getLastUserMessageID()) {

          this.saveUserMessageID(UserMessageID)
          this.settings.forEach((item, i) => {
            if (item.Key === 'UserMessage') {



              this.notificationMessage = item.Value1;
              this.showNotificationModal = true;


            }
          });

        }


      },
      (err) => { this.error = err });
  }

  onShowConfrimModal = function (card, listIndex, cardIndex, event) {
    event.stopPropagation();

    this.selectedCardToDelete = card;
    this.selectedCardToDelete.listIndex = listIndex;
    this.selectedCardToDelete.cardIndex = cardIndex;
    this.showConfrimModal = true;
  }




  onSearchClick = function () {
    if (this.searchBox && this.searchBox.replace(/\s/g, '') !== '') {
      $('.PageLoading').slideDown()
      this.services.GetCardsByKeyword({ Keyword: this.searchBox }).subscribe(
        (data) => {
          $('.PageLoading').slideUp()
          this.cardSearchList = data;
          this.cardList = null;

          $('.CardsContainer').css('overflow-x', 'hidden');
        },
        (err) => { $('.PageLoading').slideUp() });

    }
  }

  onSpeceficDayClick = function () {

    this.showSelectDayModal = true;
  }

  generateTime(Card) {
    let time = '';
    time += Card.Hour + ':';
    if (Card.Minute < 10) {
      time += '0' + Card.Minute;
    } else {
      time += Card.Minute;
    }

    return time;
  }


  generateTimeT(mode) {
    if (mode === 'AM') {
      return ' ق.ظ. '

    } else {
      return ' ب.ظ. '
    }
  }

  dayGapConvertor(input) {
    if (input === 0) {
      return 'هر روز';
    } else { return 'هر ' + input + ' روز در میان'; }


  }

  weekGapConvertor(input) {
    if (input === 0) {
      return 'هر هفته';
    } else { return 'هر ' + input + ' هفته در میان'; }


  }

  monthGapConvertor(input) {
    if (input === 0) {
      return 'هر ماه';
    } else { return 'هر ' + input + ' ماه در میان'; }


  }
  yearGapConvertor(input) {
    if (input === 0) {
      return 'هر سال';
    } else { return 'هر ' + input + ' سال در میان'; }


  }

  generateRepeatText(Card) {

    const weekDays = {
      Sat: 'ش',
      Sun: 'ی',
      Mon: 'د',
      Tue: 'س',
      Wed: 'چ',
      Thu: 'پ',
      Fri: 'ج'
    }
    let repeatText = '';
    switch (Card.FrequencyTypeID) {

      case (5):
        repeatText = Card.Day + ' ام ' + this.Var.monthesOfYear[Card.Month - 1].title + ' ماه '
          + Card.Year;
        if (Card['HasTime']) {
          repeatText += ' - ' + this.generateTime(Card) + this.generateTimeT(Card.TimeMode);
        } break;
      case (1):

        repeatText = this.dayGapConvertor(Card.GapAmount);

        if (Card['HasTime']) {
          repeatText += ' - ' + this.generateTime(Card) + this.generateTimeT(Card.TimeMode);
        } break;
      case (2):
        // tslint:disable-next-line:prefer-const
        for (let day in weekDays) {

          if (Card[day]) {
            repeatText += (weekDays[day] + ' ');
          }
        }
        repeatText += this.weekGapConvertor(Card.GapAmount);

        if (Card['HasTime']) {
          repeatText += ' - ' + this.generateTime(Card) + this.generateTimeT(Card.TimeMode);
        }

        break;
      case (3):

        repeatText = Card.Day + ' ام '
        repeatText += this.monthGapConvertor(Card.GapAmount);

        if (Card['HasTime']) {
          repeatText += ' - ' + this.generateTime(Card) + this.generateTimeT(Card.TimeMode);
        }
        break;
      case (4):
        repeatText = Card.Day + ' ام ' + this.Var.monthesOfYear[Card.Month - 1].title + ' ماه ';
        repeatText += this.yearGapConvertor(Card.GapAmount);

        if (Card['HasTime']) {
          repeatText += ' - ' + this.generateTime(Card) + this.generateTimeT(Card.TimeMode);
        }
        break;
    }


    return repeatText;
  }


  onIsDoneClick = function (card, listIndex, cardIndex, event) {
    event.stopPropagation();
    const tempCard = {
      ID: card.CardGUID,
      Year: card.Year,
      Month: card.Month,
      Day: card.Day,
      IsDone: !card.IsDone
    }
    $('.PageLoading').slideDown()
    this.services.setCardDone(tempCard).subscribe(
      (data) => {
        $('.PageLoading').slideUp()
        this.cardList.Lists[listIndex].Cards[cardIndex].IsDone = !card.IsDone;

      },
      (err) => { $('.PageLoading').slideUp() });

  }
  onConfrimDelete = function (param) {


    $('.PageLoading').slideDown()


    let info = {
      ID: this.selectedCardToDelete.CardGUID,
      IsDeleteWholeCard: param,
      Year: null,
      Month: null,
      Day: null
    }

    if (!param) {
      info.Month = this.selectedCardToDelete.Month
      info.Year = this.selectedCardToDelete.Year
      info.Day = this.selectedCardToDelete.Day
    }

    this.services.deleteCard(info).subscribe(
      (data) => {

        if (data.RStatus === 'Success') {
          this.toastr.success('حذف کارت با موفقیت انجام شد', 'عملیات موفق');

          if (this.cardList) {

   this.getCardList(this.date, false);
            // this.cardList.Lists.forEach((item, i) => {

            //   item.Cards.forEach((card, j) => {
            //     if (card.CardGUID === this.selectedCardToDelete.CardGUID) {


            //       this.cardList.Lists[i].Cards.splice(j, 1);


            //     }
            //   });
            // });
          } else {
            this.onSearchClick();
          }
          $('.PageLoading').slideUp()




        }

      },
      (err) => { $('.PageLoading').slideUp() });

    this.showConfrimModal = false;
  }





  onGetTodayClick = function () {
    const mm = moment();


    this.date = {
      Day: mm.jDate(),
      Month: mm.jMonth() + 1,
      Year: mm.jYear(),
      DaysBefore: ((mm.day() + 8) % 7),
      DaysAfter: 6 - ((mm.day() + 8) % 7)
    }
    this.getSettings();
    this.getCardList(this.date, false);

  }



  getCardList = function (date, isSpecificDate) {

    $('.PageLoading').slideDown()
    this.cardSearchList = null;


    $('.CardsContainer').css('overflow-x', 'auto');

    if (!isSpecificDate) {
      this.selectedSpecificDate = false;
    } else {
      this.date = date;
    }

    this.services.getCardList(date).subscribe(
      (data) => {
        this.cardList = data;
        $('.PageLoading').slideUp()

        this.searchBox = '';



        // if (isSpecificDate) {
        //   setTimeout(function () {
        //     $('.CardsContainer').scrollTo('#cardArea6');
        //   }, 1000);
        // }



        // $('.CardsContainer').animate({ scrollLeft: (400) }, 10);


      },
      (err) => {
        $('.PageLoading').slideUp()

      });
  }
  onAddCardClick(date) {
    this.selectedCard = null;
    this.selectedTab = 'card';
    if (date) {
      this.selectedListDate = date;
    } else {
      this.selectedListDate = null;
    }

    this.showCardModal = true;
  }

  onCardClick(card) {
    $('.PageLoading').slideDown()

    return this.services.getCard(card).subscribe(
      (data) => {
        $('.PageLoading').slideUp()

        this.selectedTab = 'card';
        this.selectedCard = data['Card'];
        this.showCardModal = true;
      },
      (err) => { $('.PageLoading').slideUp() });



  }



  onCardTimeClick(card, event) {
    $('.PageLoading').slideDown()
    event.stopPropagation();
    return this.services.getCard(card).subscribe(
      (data) => {
        $('.PageLoading').slideUp();
        if (card.HasTime === 1) {
          this.selectedTab = 'time';
        } else {
          this.selectedTab = 'repeat';
        }

        this.selectedCard = data['Card'];
        this.showCardModal = true;
      },
      (err) => { $('.PageLoading').slideUp() });



  }

  onNextWeekClick() {

    const d = this.date.Year + '/' + this.date.Month
      + '/' + this.date.Day;



    const mm = moment(d, 'jYYYY/jM/jD');

    mm.jDate(mm.jDate() + 7)




    this.date = {
      Day: mm.jDate(),
      Month: mm.jMonth() + 1,
      Year: mm.jYear(),
      DaysBefore: ((mm.day() + 8) % 7),
      DaysAfter: 6 - ((mm.day() + 8) % 7)
    }

    this.getCardList(this.date, false)

  }
  onLastWeekClick() {

    const d = this.date.Year + '/' + this.date.Month
      + '/' + this.date.Day;
    const mm = moment(d, 'jYYYY/jM/jD');

    mm.jDate(mm.jDate() - 7)

    this.date = {
      Day: mm.jDate(),
      Month: mm.jMonth() + 1,
      Year: mm.jYear(),
      DaysBefore: ((mm.day() + 8) % 7),
      DaysAfter: 6 - ((mm.day() + 8) % 7)
    }

    this.getCardList(this.date, false)
  }



  isToday(list) {

    const mm = moment();



    const d = mm.jDate();
    const m = mm.jMonth() + 1;
    const y = mm.jYear();

    if (list.Day.Year === y) {

      if (list.Day.Month === m) {

        if (list.Day.Day === d) {

          return true;
        }
      }
    }
    return false;
  }


  isSpecificDate(list) {
    let found = false;
    if (!this.selectedSpecificDate) {

    } else {

      if (list.Day.Year === this.selectedSpecificDate.Year) {

        if (list.Day.Month === this.selectedSpecificDate.Month) {

          if (list.Day.Day === this.selectedSpecificDate.Day) {

            found = true;
          }
        }
      }

    }


    return found;
  }

  ngOnInit() {

    this.getSettings();




    const pauseEvent = function (e) {

      if (e.stopPropagation) {
        e.stopPropagation();
      }
      if (e.preventDefault) {
        e.preventDefault();
      }
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    }


    if (this.security.checkToken()) {

      this.getCardList(this.date, false);
    }



    // tslint:disable-next-line:prefer-const
    let self = this;


    // tslint:disable-next-line:no-shadowed-variable

    $('#scroll-left').mousedown(function (e) {

      startScrolling($('.CardsContainer'), '-=8px', true);
    }).mouseup(function () {
      $('.CardsContainer').stop()
    });
    $('#scroll-right').mousedown(function (e) {

      startScrolling($('.CardsContainer'), '+=8px', true);
    }).mouseup(function () {
      $('.CardsContainer').stop();
    });




    // $('#scroll-left').click(function (e) {
    //   e.stopImmediatePropagation();
    //   $('.CardsContainer').animate({
    //     scrollLeft: '-=400px'
    //   }, 'fast');


    // });
    // $('#scroll-right').click(function (e) {
    //   e.stopImmediatePropagation();
    //   $('.CardsContainer').animate({
    //     scrollLeft: '+=400px'
    //   }, 'fast');


    // });



    // $('.CardsContainer')
    //   .scroll(
    //   function () {



    //     this.initialized = true;
    //     if ($(this).scrollLeft()
    //       + $(this).innerWidth() > $(this)[0].scrollWidth - 300) {



    //       self.appendCardList(self.date, 'right');
    //     } else if ($(this).scrollLeft()
    //       < 300) {
    //       self.appendCardList(self.date, 'left');
    //     }

    //   });









    $.fn.attachDragger = function () {
      let lastPosition, position, difference;
      $($(this).selector).on(
        'mousedown mouseup mousemove',
        function (e) {

          e = e || window.event;
          pauseEvent(e);

          if (e.type === 'mousedown') {
            this.attachment = true, lastPosition = [e.clientX,
            e.clientY];
          }
          if (e.type === 'mouseup') {
            this.attachment = false;
          }
          if (e.type === 'mousemove' && this.attachment === true) {
            position = [e.clientX, e.clientY];
            difference = [(position[0] - lastPosition[0]),
            (position[1] - lastPosition[1])];
            $(this)
              .scrollLeft(
              $(this).scrollLeft() - difference[0]);
            $(this).scrollTop($(this).scrollTop() - difference[1]);
            lastPosition = [e.clientX, e.clientY];
          }
        });
      $(window).on('mouseup', function () {
        this.attachment = false;
      });
    }
    $(document).ready(function () {
      $('.CardsContainer').attachDragger();

    });



















  }




  show() {
    this.toastr.error('مشکلی در سامانه رخ داده است', 'خطا');

  }








  @HostListener('document:keydown', ['$event']) onKeyDown(e) {
    if (e.shiftKey && e.keyCode === 78) {

      this.onAddCardClick(null);
      e.stopPropagation()
      e.preventDefault();
    } else if (e.shiftKey && e.keyCode === 83) {
      e.stopPropagation()
      e.preventDefault();
      $('#search').focus();
    } else if (e.keyCode === 27) {
      e.stopPropagation()
      e.preventDefault();


      this.closeCardModal();


    }

  }



}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/card/app.card.component.ts